const IST_TIMEZONE = 'Asia/Kolkata';
let patched = false;

type DateLocaleFn = (this: Date, locales?: Intl.LocalesArgument, options?: Intl.DateTimeFormatOptions) => string;

function withISTTimezone(options?: Intl.DateTimeFormatOptions): Intl.DateTimeFormatOptions {
  if (!options || !options.timeZone) {
    return { ...(options || {}), timeZone: IST_TIMEZONE };
  }
  return options;
}

function patchDateLocaleMethod(methodName: 'toLocaleString' | 'toLocaleDateString' | 'toLocaleTimeString') {
  const original = Date.prototype[methodName] as DateLocaleFn;
  Date.prototype[methodName] = function patched(this: Date, locales?: Intl.LocalesArgument, options?: Intl.DateTimeFormatOptions) {
    return original.call(this, locales, withISTTimezone(options));
  } as DateLocaleFn;
}

export function applyISTLocaleDefaults() {
  if (typeof Date === 'undefined' || patched) {
    return;
  }
  patchDateLocaleMethod('toLocaleString');
  patchDateLocaleMethod('toLocaleDateString');
  patchDateLocaleMethod('toLocaleTimeString');
  patched = true;
}
